// extracted by mini-css-extract-plugin
export var actionText = "_ox-4";
export var container = "_ox-0";
export var leftSection = "_ox-1";
export var rightSection = "_ox-2";
export var settingsButton = "_ox-6";
export var settingsIcon = "_ox-7";
export var shortcut = "_ox-5";
export var shortcutGroup = "_ox-3";